import { render, staticRenderFns } from "./dashoboard-sale-instant.vue?vue&type=template&id=7cacc3e9&scoped=true&"
import script from "./dashoboard-sale-instant.vue?vue&type=script&lang=js&"
export * from "./dashoboard-sale-instant.vue?vue&type=script&lang=js&"
import style0 from "./dashoboard-sale-instant.vue?vue&type=style&index=0&id=7cacc3e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cacc3e9",
  null
  
)

export default component.exports